import api from "../../../services/api";
import { gmapApi } from "vue2-google-maps";
import moment from "moment";
import formatcoords from "formatcoords";
import helpers from "../../../shared/fleetbox-helpers";
import { Marker, GeoPosition, Polyline } from "../../../domain/poi";
import { bus } from "../../../main";
import mapPoiCategoriesFilter from "../../../components/map/poicategories.vue";
import trafficLayer from "../../../components/map/viewtraffic.vue";
import { mapGetters } from "vuex";

export default {
	components: {
		mapPoiCategoriesFilter,
		trafficLayer
	},
	props: {
		data: Array,
		fastestRoute: Boolean,
		shortestRoute: Boolean
	},
	data: function() {
		return {
			firstTimeIn: true,
			center: {},
			markers: [],
			infoContent: "",
			infoWindowPos: null,
			infoWinOpen: false,
			currentMidx: null,
			infoOptions: {
				content: "",
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			paths: [],
			areas: [],
			edited: null,
			indexItem: 0,
			itemIsAlreadyAdded: false,
			tooltipInfoCustomClass: "glow",

			//POI
			poiAreas: [],
			poiPaths: [],
			poiMarkers: [],

			viewSatellite: false,
			mapStylesOptions: [ 
				{
					featureType: "poi",
					stylers: [ 
						{ 
							visibility: "off" 
						} 
					] 
				} 
			],
		};
	},
	watch: {
		// data: {
		// 	handler() {
		// 		this.displayPath();
		// 	},
		// 	deep: true
		// }
	},
	created() {
		var self = this;

		if (this.settings && this.settings.viewSatellite) {
			this.viewSatellite = this.settings.viewSatellite;
		}

		this.center = {
			lat: 43.1107,
			lng: 12.3908
		};

		bus.$on("on-detail-route-show", this.onDetailRouteShow.bind(this));

		bus.$on("poi-category-filter-change", self.onPoiCategoryFilterChange.bind(self));
	},
	mounted() {
		/* poi categories */
		var self = this;
		if (this.settings && this.settings.viewPoi) {
			this.$nextTick(() => {
				self.$refs.map.$gmapApiPromiseLazy().then(res => {
					self.$refs.poiCatgeoriesFilter.loadControls(self.$refs.map);
				});
				//}, 1000);
			});
		}
		/* poi categories */
		/* traffic Layer */
		if (this.settings && this.settings.viewTraffic) {
			self.$refs.map.$gmapApiPromiseLazy().then(res => {
				self.$refs.map.$mapPromise.then(map => {
					var trafficLayer = new google.maps.TrafficLayer();
					self.$refs.trafficLayer.loadControls(self.$refs.map);
				});
			});
		}
		/* traffic Layer */
	},
	beforeDestroy() {
		var self = this;
		bus.$off("poi-category-filter-change", self.onPoiCategoryFilterChange.bind(self));
	},
	/* metodi */
	methods: {
		onInfoWindowPathDomReady(index, selected) {
			this.highlightTooltipPath(index, selected);
		},
		onTooltipPathClick(index, selected) {
			var infoTooltipElements = Object.keys(this.$refs).filter(function(item) {
				return item.indexOf("infoTooltip") >= 0;
			});
			for (var i = 0; i < infoTooltipElements.length; i++) {
				var key = infoTooltipElements[i];
				var keySplitted = key.split("_");
				if (keySplitted.length > 1) {
					var parentDiv = this.$refs[key][0].parentElement;
					if (parentDiv) {
						parentDiv = parentDiv.parentElement;
						if (parentDiv) {
							parentDiv = parentDiv.parentElement;
							if (parentDiv) {
								parentDiv.classList.remove(this.tooltipInfoCustomClass);
							}
						}
					}
				}
			}

			this.hightlightPath(index);
			this.highlightTooltipPath(index, selected);
		},
		highlightTooltipPath(index, selected) {
			var pardiv = this.$refs[`infoTooltip_${index}`][0].parentElement.parentElement.parentElement;
			if (pardiv) {
				if (selected) pardiv.classList.add(this.tooltipInfoCustomClass);
				else pardiv.classList.remove(this.tooltipInfoCustomClass);
			}
		},
		markerOut() {
			helpers.deleteTooltip();
		},
		markerOver($event, m) {
			helpers.injectTooltip($event.tb, m.description);
		},
		displayPois: function(data) {
			var self = this;

			//items to remove - marker
			var itemsToRemove = [];
			for (let i = 0; i < this.poiMarkers.length; i++) {
				var m = this.poiMarkers[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiMarkers.findIndex(function(o) {
					return o.id == r;
				});

				self.poiMarkers.splice(index, 1);
			});

			//items to remove - polygon
			itemsToRemove = [];
			for (let i = 0; i < this.poiPaths.length; i++) {
				var m = this.poiPaths[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiPaths.findIndex(function(o) {
					return o.id == r;
				});

				self.poiPaths.splice(index, 1);
			});

			//items to remove - area
			itemsToRemove = [];
			for (let i = 0; i < this.poiAreas.length; i++) {
				var m = this.poiAreas[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiAreas.findIndex(function(o) {
					return o.id == r;
				});

				self.poiAreas.splice(index, 1);
			});

			data.forEach(function(item) {
				if (item.location.rendering_type == "marker" || (item.location.rendering_type == "unknown" && item.location.points.length == 1)) {
					let m = _.find(self.poiMarkers, function(o) {
						return o.id == item.id;
					});

					if (m == null) {
						m = new google.maps.Marker();
						m.id = item.id;
						m.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: -40
							}
						};

						self.poiMarkers.push(m);
					}

					m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
					m.description = item.name;
					m.info = `<div style="padding: 10px;"><b>${item.name}</b><br />
								LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
								INDIRIZZO: ${item.location.address}<br /></div>`;

					if (item.poi_category_icon_image) {
						var icon = {
							url: item.poi_category_icon_image,
							scaledSize: new google.maps.Size(30, 36), // scaled size
							origin: new google.maps.Point(0, 0) // origin
						};
						m.icon = icon;
					}
					m.infoWindowOptions.content = m.info;
				} else if (item.location.rendering_type == "polygon" || (item.location.rendering_type == "unknown" && item.location.points.length > 1)) {
					//marker related to polygon
					if (!self.isInEditMode) {
						let m = _.find(self.poiMarkers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.poiMarkers.push(m);
						}

						m.draggable = false;
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.description = item.name;
						m.info = `<div style="padding: 10px;"><b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br /></div>`;
						if (item.poi_category_icon_image) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					}

					//polygon
					let p = _.find(self.poiPaths, function(o) {
						return o.id == item.id;
					});

					if (p == null) {
						p = {
							id: item.id,
							path: item.location.points.map(function(pt) {
								return new GeoPosition(pt.lat, pt.lon);
							}),
							infoWindowOptions: {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: 0
								}
							}
						};

						self.poiPaths.push(p);
					}

					p.fillColor = item.poi_category_fill_color;
					p.description = item.name;
					p.info = `<div style="padding: 10px;"><b>${item.name}</b><br />
									LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									INDIRIZZO: ${item.location.address}<br /></div>`;
					p.infoWindowOptions.content = p.info;
				} else if (item.location.rendering_type == "circle") {
					//marker related to circle
					if (!self.isInEditMode) {
						let m = _.find(self.poiMarkers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.poiMarkers.push(m);
						}

						m.draggable = item.draggable;
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.description = item.name;
						m.info = `<div style="padding: 10px;"><b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br /></div>`;
						if (item.poi_category_icon_image) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					}
					//area
					let a = _.find(self.poiAreas, function(o) {
						return o.id == item.id;
					});

					if (a == null) {
						a = new google.maps.Circle();
						a.id = item.id;
						a.radius = item.radius;
						a.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: 0
							}
						};

						self.poiAreas.push(a);
					}
					a.center = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
					a.fillColor = item.poi_category_fill_color;
					a.description = item.name;
					a.info = `<div style="padding: 10px;"><b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br /></div>`;
					a.infoWindowOptions.content = a.info;
				}
			});
		},
		poiMarkerClick: function(marker) {
			helpers.deleteTooltip();
			this.hideAllInfoWindow();
			this.toggleInfoWindow(marker);
		},
		onPoiCategoryFilterChange(items) {
			this.displayPois(items);
		},
		onDetailRouteShow(index) {
			var path = this.paths[index];
			this.polylineClick(path, index);
		},
		displayPath() {
			this.paths = [];
			this.markers = [];

			var self = this;
			this.$nextTick(function() {
				if (self.data) {
					var legs = self.data[0].legs;

					legs.forEach(location => {
						var mStart = new Marker();

						mStart.position.lat = location.start_location.lat;
						mStart.position.lng = location.start_location.lon;

						mStart.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: -40
							}
						};

						mStart.info = `<div class=mrkPl>${location.start_address}</div>`;
						mStart.infoWindowOptions.content = mStart.info;
						mStart.description = "Partenza";
						var iconStart = {
							url: "/icon-start.png",
							scaledSize: new google.maps.Size(30, 50), // scaled size
							origin: new google.maps.Point(0, 0) // origin
						};
						mStart.icon = iconStart;
						self.markers.push(mStart);

						var mEnd = new Marker();

						mEnd.position.lat = location.end_location.lat;
						mEnd.position.lng = location.end_location.lon;

						mEnd.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: -40
							}
						};
						mEnd.info = `<div class=mrkPl>${location.end_address}</div>`;
						mEnd.infoWindowOptions.content = mEnd.info;
						mEnd.description = "Arrivo";
						var iconEnd = {
							url: "/icon-end.png",
							scaledSize: new google.maps.Size(30, 50), // scaled size
							origin: new google.maps.Point(0, 0) // origin
						};
						mEnd.icon = iconEnd;
						self.markers.push(mEnd);
					});

					var minDistance = 1000000;
					var minRouteDistanceIndex = 0;
					var minDuration = 1000000;
					var minRouteDurationIndex = 0;
					var index = 0;
					self.data.forEach(route => {
						var path = route.overview_polyline;
						var points = helpers.decodeGooglePolyline(path.points);
						var coordinates = points.map(function(item) {
							return {
								lat: item[0],
								lng: item[1]
							};
						});

						var line = new google.maps.Polyline();
						var distance = 0;
						var duration = 0;
						route.legs.forEach(leg => {
							distance += leg.distance.value;
							duration += leg.duration.value;
						});

						if (duration < minDuration) {
							minDuration = duration;
							minRouteDurationIndex = index;
						}

						if (distance < minDistance) {
							minDistance = distance;
							minRouteDistanceIndex = index;
						}

						line.tootlipPoint = parseInt(coordinates.length / 2);

						var distanceKmToString = "";
						var userFriendlyTime = self.$options.filters.timeFromSecondsToStringFriendly(duration);
						var dKm = distance / 1000;
						if (distance > 100000) {
							distanceKmToString = parseInt(dKm);
						} else {
							distanceKmToString = dKm.toFixed(2);
						}

						line.infoWindowOptions = {
							infoWindowOpened: true,
							pixelOffset: {
								width: 0,
								height: 0
							},
							zIndex: 0
						};
						line.userFriendlyTime = userFriendlyTime;
						line.distanceKmToString = distanceKmToString;
						// line.info = `<div class="container-fluid" style="width: 130px; cursor:pointer">
						// 				<div class="row">
						// 					<div class="col-md-6" style="padding: 0; text-align: center;">
						// 						<img width="35" src="/icon-pinmap-car.png" />
						// 					</div>
						// 					<div class="col-md-6" style="padding: 0;">
						// 						<b>${userFriendlyTime}</b><br /><b>${distanceKmToString} Km</b>
						// 					</div>
						// 				</div>
						// 			 </div>`;
						// line.infoWindowOptions.content = line.info;

						line.selected = false;
						line.path = coordinates;
						line.otherOptions = {
							strokeColor: "#787878", //"#4986E7",
							strokeOpacity: 0.7,
							strokeWeight: 4,
							zIndex: 0
						};
						line.bestOptions = {
							strokeColor: "#4986E7",
							strokeOpacity: 1.0,
							strokeWeight: 4,
							zIndex: 1
						};
						line.zIndex = 0;
						self.paths.push(line);
						index++;

						self.fitAndZoom();
					});

					if (self.shortestRoute) {
						self.paths[minRouteDistanceIndex].selected = true;
						self.paths[minRouteDistanceIndex].infoWindowOptions.zIndex = 1;
						//this.paths[minRouteDistanceIndex].zIndex = 1;
					}
					if (self.fastestRoute) {
						self.paths[minRouteDurationIndex].selected = true;
						self.paths[minRouteDurationIndex].infoWindowOptions.zIndex = 1;
						//this.paths[minRouteDurationIndex].zIndex = 1;
					}
				}
			});
		},
		fitAndZoom: function() {
			var self = this;

			var bounds = new google.maps.LatLngBounds();

			self.markers.forEach(function(item, index) {
				bounds.extend(item.position);
			});
			self.paths.forEach(function(item, index) {
				item.path.forEach(p => {
					bounds.extend(p);
				});
			});

			self.$refs.map.$mapPromise.then(map => {
				map.fitBounds(bounds);

				var listener = google.maps.event.addListener(map, "idle", function() {
					google.maps.event.removeListener(listener);
				});
			});
		},
		mapClickhandler(e) {},
		polylineClick(path, idx) {
			path.infoWindowOptions.infoWindowOpened = true;

			this.onTooltipPathClick(idx, true);
		},
		hightlightPath(idx) {
			var index = 0;
			this.paths.forEach(p => {
				if (index == idx) {
					p.selected = true;
					p.infoWindowOptions.zIndex = 1;
				} else {
					p.selected = false;
					p.infoWindowOptions.zIndex = 0;
				}

				index++;
			});
		},
		markerClick: function(marker, idx) {
			this.$emit("onMarkerClick", { marker, idx });

			this.hideAllInfoWindow();

			this.toggleInfoWindow(marker);
		},
		hideAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			//POI
			self.poiMarkers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.poiPaths.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.poiAreas.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});
		},
		showAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = true;
			});
		},
		centerMap: function(position) {
			var self = this;

			self.$refs.map.$mapPromise.then(map => {
				map.setCenter(position);
			});
		},
		toggleInfoWindow: function(marker, idx) {
			marker.infoWindowOptions.infoWindowOpened = !marker.infoWindowOptions.infoWindowOpened;
		}
	},
	computed: {
		...mapGetters(["settings"])
	}
};
